/**
 * Polyfill - define all polyfills here
 */

import ObjectValues from 'object.values'
import ArrayFrom from 'array-from'

if (!global.Object) {
  global.Object = function(obj) {
    if (!obj) {
      return {}
    } else {
      return obj
    }
  }
}

if (!global.Object.values) {
  global.Object.values = ObjectValues
}
if (!Array.from) {
  Array.from = ArrayFrom
}

(function () {
  if (typeof window.CustomEvent === 'function') { return false }
  function CustomEvent (event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined }
    var evt = document.createEvent('CustomEvent')
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
    return evt
  }
  CustomEvent.prototype = window.Event.prototype
  window.CustomEvent = CustomEvent
})()



// WEBPACK FOOTER //
// ./assets/js/helpers/Polyfills.jsx